/**
 * Application configuration
 */

// Detect if running on Capacitor native platform
// Check at runtime - Capacitor is available in mobile apps
const isCapacitorNative = (() => {
  try {
    // Check if Capacitor is available (will be in mobile app builds)
    if (typeof window !== 'undefined') {
      // Check for Capacitor in window (injected by Capacitor runtime)
      if (window.Capacitor && window.Capacitor.isNativePlatform) {
        return window.Capacitor.isNativePlatform();
      }
      // Alternative: Check for Capacitor webview indicators
      if (window.location.protocol === 'capacitor:' || 
          window.location.protocol === 'capacitor-https:' ||
          window.location.protocol === 'capacitor-http:') {
        return true;
      }
      // Check user agent for Capacitor indicators
      if (navigator.userAgent && navigator.userAgent.includes('Capacitor')) {
        return true;
      }
    }
    return false;
  } catch (e) {
    return false;
  }
})();

// Automatically detect if we're in production or development based on domain
// For Capacitor mobile apps, use dev environment for now
const isProduction = !isCapacitorNative && (
  window.location.hostname === 'easyhealthdigital.com' || 
  window.location.hostname === 'www.easyhealthdigital.com'
);
  
const isDevelopment = isCapacitorNative 
  ? true  // Mobile apps use dev environment for now
  : (window.location.hostname === 'dev.easyhealthdigital.com' || 
     window.location.hostname === 'www.dev.easyhealthdigital.com');

// Replace YOUR_LOCAL_IP with your actual IP (e.g., 192.168.1.100)
const LOCAL_IP = 'localhost';

export const config = {
  debugOtp: false,
  mapsApiKey: 'AIzaSyA6xFjorrByqcT7crcd17DwnTLR8GoR5ac',
  isCapacitorNative, // Export for use in other components
  // Backend configuration
  backend: {
    // Backend host with port - automatically detect based on current domain
    // For Capacitor mobile apps, always use production URL
    host: isProduction 
      ? 'https://easyhealthdigital.com'
      : isDevelopment
      ? 'https://dev.easyhealthdigital.com'
      : `http://${LOCAL_IP}:8000`,
    
    // WebSocket configurations
    ws: {
      // WebSocket host with port - automatically detect based on current domain
      // For Capacitor mobile apps, use production WebSocket host
      host: isProduction
        ? (isCapacitorNative ? 'easyhealthdigital.com' : window.location.host)
        : isDevelopment
        ? 'dev.easyhealthdigital.com'
        : `${LOCAL_IP}:8000`,
      
      // WebSocket endpoints
      endpoints: {
        admin: '/ws/admin/notifications',
        bda: '/ws/bda/notifications',
        patient: '/ws/patient/notifications'
      }
    }
  }
};

// Debug the final config
console.log('🎯 Final API Host:', config.backend.host);
console.log('🎯 Final WebSocket Host:', config.backend.ws.host);

export default config; 

